export const BM = {
    DYNAMIC: true,
    SHADOW: false,
    COMPOSED: false,
    DOMLIKE: false,
};
export var BackendMode;
(function (BackendMode) {
    BackendMode[BackendMode["Shadow"] = 1] = "Shadow";
    BackendMode[BackendMode["Composed"] = 2] = "Composed";
    BackendMode[BackendMode["Domlike"] = 3] = "Domlike";
})(BackendMode || (BackendMode = {}));
export var ResizeObserverMode;
(function (ResizeObserverMode) {
    ResizeObserverMode[ResizeObserverMode["ContentBox"] = 1] = "ContentBox";
    ResizeObserverMode[ResizeObserverMode["BorderBox"] = 2] = "BorderBox";
})(ResizeObserverMode || (ResizeObserverMode = {}));
//# sourceMappingURL=shared.js.map